import script from "./ProductVideos.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductVideos.vue?vue&type=script&setup=true&lang=js"

import "./ProductVideos.vue?vue&type=style&index=0&id=0cc6d1d0&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/mayesh.com/httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc6d1d0"]])

export default __exports__